import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { CLOSE_DIALOG_EVENT } from '@rio-cloud/rio-uikit/FrameDialog';
import usePostMessageSender from '@rio-cloud/rio-uikit/usePostMessageSender';

const BATTERY_SERVICE_DIALOGS = 'BATTERY-SERVICE-DIALOGS';

const PackHistoryDialog = () => {
    const { sendMessageToParent } = usePostMessageSender();

    const handleCloseDialog = useCallback(() => {
        sendMessageToParent({
            type: `${BATTERY_SERVICE_DIALOGS}${CLOSE_DIALOG_EVENT}`,
            payload: 'Closed Pack History dialog',
        });
    }, [sendMessageToParent]);

    return (
        <div className="display-flex justify-content-between align-items-center padding-10 border-style-solid border-bottom-only border-width-1 border-color-light">
            <span className="text-size-22">
                <FormattedMessage id="intl-msg:batteryService.batteryPackLevel.history" />
            </span>
            <button
                type="button"
                className="btn btn-icon-only btn-muted close"
                onClick={handleCloseDialog}
                aria-label="dialog close button"
            >
                <span className="rioglyph rioglyph-remove" aria-hidden="true" />
            </button>
        </div>
    );
};

export default PackHistoryDialog;
